import { createContext } from "react";

const DatabaseContext = createContext({});

export default DatabaseContext;
